import {h, Fragment} from 'preact'
import css from 'minify-css.macro'
import {Box} from '@dash-ui/react-layout'
import {styles} from '../styles'
import type {BoxProps} from '@dash-ui/react-layout'

export const Notice: React.FC<NoticeProps> = ({variant = 'info', ...props}) => (
  <Box
    className={notice(variant)}
    {...props}
    children={
      <Fragment>
        {props.children}
        <span className={noticeBorder()} />
      </Fragment>
    }
  />
)

const notice = styles({
  default: ({pad, radius}) => css`
    width: 100%;
    padding: ${pad.md};
    border-radius: ${radius.primary};
    overflow: hidden;
    text-align: left;
  `,
  info: ({color}) => css`
    background-color: ${color['intention/info']};
    color: ${color['intention/infoInverse']};
  `,
  danger: ({color}) => css`
    background-color: ${color['intention/danger']};
    color: ${color['intention/dangerInverse']};
  `,
})

const noticeBorder = styles.one(css`
  height: 3px;
  width: 100%;
  background-color: currentColor;
  position: absolute;
  bottom: 0;
  left: 0;
`)

export interface NoticeProps extends BoxProps {
  variant?: 'info' | 'danger'
}
